module.exports = __webpack_public_path__ + "img/banner_sanfang@2x.d09bdb5c.png";